'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { apiClient } from '@/lib/api/client'

export function AcceptInvitation({ token }: { token: string }) {
  const [status, setStatus] = useState<'loading' | 'accepted' | 'failed'>('loading')
  const [message, setMessage] = useState('Accepting invitation...')

  useEffect(() => {
    let cancelled = false

    async function accept() {
      try {
        const invitation = await apiClient.acceptHelmInvitation(token)
        if (cancelled) return
        setStatus('accepted')
        setMessage(`Invitation accepted for ${invitation.invited_email}.`)
      } catch (error) {
        if (cancelled) return
        setStatus('failed')
        setMessage(error instanceof Error ? error.message : 'Failed to accept invitation')
      }
    }

    accept()

    return () => {
      cancelled = true
    }
  }, [token])

  if (status === 'loading') {
    return (
      <Alert>
        <Loader2 className="h-4 w-4 animate-spin" />
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    )
  }

  return (
    <div className="space-y-4">
      <Alert variant={status === 'accepted' ? 'default' : 'destructive'}>
        {status === 'accepted' ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}
        <AlertDescription>{message}</AlertDescription>
      </Alert>

      <Link href="/">
        <Button>Open Dashboard</Button>
      </Link>
    </div>
  )
}
